import React from 'react';
import { TdComponent, TrComponent } from '../../../wrappers';
import * as PropTypes from 'prop-types';
import css from './TrGridBody.module.scss';
import classNames from 'classnames';

const TrGridBody = ({ sticky, tr, callbackfn, handlersTR, o, trStyle }) => {
    return (
        <React.Fragment>
            <TrComponent
                sticky={sticky}
                {...handlersTR}
                style={{
                    ...trStyle.style
                }}
                className={classNames(
                    'tr-component',
                    tr?.effects !== false && css.trHover,
                    Object.keys(handlersTR).length && css.cursorPointer,
                    trStyle.className
                )}
            >
                {Object.keys(o).map(callbackfn)}
            </TrComponent>
            {o.addedComponent ? (
                <TrComponent sticky={sticky} colSpan={99999}>
                    <TdComponent sticky={sticky} className={css.addedComponentInner} colSpan={99999}>
                        {o.addedComponent}
                    </TdComponent>
                </TrComponent>
            ) : null}
        </React.Fragment>
    );
};

TrGridBody.propTypes = {
    sticky: PropTypes.any,
    handlersTR: PropTypes.any,
    trStyle: PropTypes.any,
    tr: PropTypes.any,
    o: PropTypes.any,
    callbackfn: PropTypes.func
};

export default TrGridBody;
